import { all } from 'redux-saga/effects'
import { loaderSaga } from './loader/saga'

export function* userSaga() {
  yield all([loaderSaga()])
}
